module.exports = __webpack_public_path__ + "static/series_3000-29fd9574bc74f130271820bddedb0e80.png";